<template>
  <b-row align-h="center">
    <div
      v-if="loading"
      class="loader"
    />
  </b-row>
</template>
<script>
export default {
  name: 'SpinnerLoader',
  props: {
    loading: { type: Boolean, default: true },
  },
}
</script>
<style lang="scss">
.loader {
  border: 5px solid #f3f3f3;
  border-top: 5px solid #008087;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
  place-self: center;
  margin-bottom:2em
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
